import React, { createContext, useEffect, useState } from 'react'
import { sn_url } from 'utils/js/endpoints'
import { handleError } from 'utils/js/error_helpers'

export const AdsContext = createContext(false)

export const AdsProvider = ({ children }) => {
    const [ads, setAds] = useState(0)
    const [adTargets, setAdTargets] = useState({})
    const [siteTargetings, setSiteTargetings] = useState({})

    useEffect(() => {
        updateAdTargets().catch(err => {
            handleError(err)
        })
        updateSiteTargeting().catch(err => {
            handleError(err)
        })
    }, [])

    const updateSiteTargeting = () => {
        return fetch(`${sn_url}/wp-json/rsm-adutil/v1/site_targetings/`)
            .then(response => response.json())
            .then(res => {
                setSiteTargetings(res)
                return true
            })
            .catch(err => {
                handleError(err)
                return false
            })
    }
    const updateAdTargets = async () => {
        let currentURL = sn_url.replace('https://', '')
        currentURL = currentURL + window.location.pathname

        let endpoint = sn_url + '/wp-json/rsm-adutil/v1/get_ad_targets_by_url/' + currentURL

        return fetch(endpoint)
            .then(response => response.json())
            .then(res => {
                // Temporarily set ads data to the window object until we can refactor all ads components to use react context. (TO BE COMPLETED IN NHLWEB-15954)
                window.adTargets = function() {
                    return res
                }

                if (res.ad_unit_path) {
                    window.adUnitPath = res.ad_unit_path
                } else {
                    window.adUnitPath = '/7326/en.sportsnet.web/' + res.section
                }
                setAdTargets(res)

                return true
            })
            .catch(err => {
                handleError(err)
                return false
            })
    }

    return (
        <AdsContext.Provider value={{ ads, setAds, siteTargetings, adTargets, updateAdTargets }}>
            {children}
        </AdsContext.Provider>
    )
}

export default AdsContext
